import { Component, type OnInit } from '@angular/core'
import ApplicationSections from '../../core/json-data/application-sections.json'
import { environment } from 'src/environments/environment'

@Component({
  standalone: false,
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  $ApplicationSections: typeof ApplicationSections = []

  ngOnInit () {
    this.$ApplicationSections = this.filterSectionsByStage(ApplicationSections[0])
  }

  private filterSectionsByStage (sections: any[]): any[] {
    const stage = environment.stage

    let filtered = JSON.parse(JSON.stringify(sections))

    if (stage === 'v2demo') {
      return [filtered]
    }

    if (stage === 'dev') {
      return [filtered.filter(section => section.name !== 'AI')]
    }

    if (stage === 'jcpdev' || stage === 'jcpprd' || stage === 'aerodv') {
      // aerodv mirrors jcp but also keeps Buy Planning (Recommended Buy Quantity / RBQ)
      const removedSections = stage === 'aerodv' ? ['AI'] : ['Buy Planning', 'AI']
      filtered = filtered.filter(section => !removedSections.includes(section.name))
      const blockedRoutes = ['size-distro-strategy/size-range-assignments']
      filtered.forEach(category => {
        category.children?.forEach(child => {
          if (child.level === 'section' && Array.isArray(child.children)) {
            child.children = child.children.filter(screen => !blockedRoutes.includes(screen.route))
          }
        })
      })
      return [filtered]
    }

    // For all other stages: remove Performance, Buy Planning, and AI
    filtered = filtered.filter(
      section => section.name !== 'Performance' && section.name !== 'Buy Planning' && section.name !== 'AI'
    )

    const blockedRoutes = ['size-distro-strategy/size-range-assignments']

    filtered.forEach(category => {
      category.children?.forEach(child => {
        if (child.level === 'section' && Array.isArray(child.children)) {
          child.children = child.children.filter(screen => !blockedRoutes.includes(screen.route))
        }
      })
    })

    return [filtered]
  }
}
